require('@173js/ui/preventEmptyHrefClick')
require('widgets/common')
require('shouyou/widgets/gameInfoSection')
require('./widgets/shortVideo')

$(function() {
  $('.gb-final-mod-article').prepend('<style type="text/css">.gb-final-mod-article .article-link-big-image::after{display:block;content:"查看大图"}</style>');
  $('.gb-final-mod-article .p-image img').each(function(){
    var w = $(this).attr('width')
    if(w && w > 540) {
      $(this).parents('a').addClass('article-link-big-image');
    }
  });
})
